import { reactive, readonly, inject } from "vue";

const ToastSymbol = Symbol("Toast");

export function createToast() {
  const state = reactive({
    messages: [],
  });

  const add = (input) => {
    let summary = input.summary || "info";
    let detail = input.detail || "info";
    let severity = input.severity || "info";
    let life = input.life || 0;
    const id = Date.now();
    state.messages.push({
      id,
      summary,
      detail,
      severity,
      life,
      startTime: Date.now(),
      progress: 100,
    });
    if (life === 0) return;
    setTimeout(() => {
      const index = state.messages.findIndex((toast) => toast.id === id);
      if (index !== -1) {
        state.messages.splice(index, 1);
      }
    }, life);
  };

  const removeAllToasts = () => {
    state.messages = [];
  }

  const removeToast = (id) => {
    const index = state.messages.findIndex((toast) => toast.id === id);
    if (index !== -1) {
      state.messages.splice(index, 1);
    }
  }

  return {
    install(app) {
      app.provide(ToastSymbol, {
        messages: readonly(state.messages),
        add,
        removeAllToasts,
        removeToast,
      });
      app.config.globalProperties.$toast = {
        add,
        removeAllToasts,
        removeToast,
      };
    },
  };
}

export function useToast() {
  const toast = inject(ToastSymbol);
  if (!toast) {
    throw new Error("Toast plugin is not installed.");
  }
  return toast;
}